import React from 'react';
import { connect } from 'react-redux';
import { useIsDesktopDimension, useIsMobileDimension } from '@beef/ui-kit/hooks';
import { compose, isNullOrUndefined } from '@beef/utils';
import { Anchor, Flex } from '@fttb/common';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { CityChangeButton } from "./components/CityChangeButton";
import { withAnalyticsOnBlockView } from "../hoc/withAnalyticsOnView";
import { getAnalyticEventType } from "../../store/blocks/selectors";
import { getCheckTitle, getCurrentCity } from "../../store/blocks/checkAddress/selectors";
import { getTariffsList, showPopularTariff } from "../../store/blocks/tariffs/selectors";
import { getCheckAddressConnected, getCheckAddressHSConnected, getRenderTooltip } from "../../store/checkAddress/selectors";
import { FttbBlocks } from "../constants";
import { defineBlock } from "../utils";
import { AddressHousePoint, AddressMap, CheckAddressWrapper, ConnectionStatus, FallbackBanner, MultiHeading, PopularTariff, WidgetContainer } from "./components";
import { AvalibleWrapper } from "./components/AvalibleWrapper";
import { AddressFinalForm, AddressMobileFinalForm, AvailableHighSpeedMapTooltip, AvailableMapTooltip, CallablePhone, CheckButton, CityLabel, ConnectButton, FallbackBannerHeading, FlatInput, HouseInput, NotAvailableMapTooltip, PopularTariffHeading, StreetInput } from "./connected";
var _CheckAddressBlock = function _CheckAddressBlock(_ref) {
  var isAddressConnected = _ref.isAddressConnected,
    isAddressHSConnected = _ref.isAddressHSConnected,
    hasPopularTariff = _ref.hasPopularTariff,
    className = _ref.className,
    renderTooltip = _ref.renderTooltip;
  var isDesktop = useIsDesktopDimension();
  var isMobile = useIsMobileDimension();
  return isMobile ? /*#__PURE__*/React.createElement(AddressMobileFinalForm, {
    className: className,
    "data-t-id": "blocks-CheckAddressBlock"
  }, /*#__PURE__*/React.createElement(Anchor, {
    anchorId: FttbBlocks.CHECK_ADDRESS,
    "data-t-id": "blocks-CheckAddressBlock"
  }), /*#__PURE__*/React.createElement(MultiHeading, {
    className: "mar-b-m",
    phone: /*#__PURE__*/React.createElement(CallablePhone, null)
  }), /*#__PURE__*/React.createElement(CityLabel, {
    className: "mar-b-xs"
  }), /*#__PURE__*/React.createElement(CityChangeButton, {
    className: "mar-b-xl",
    width: "100%"
  }), /*#__PURE__*/React.createElement(StreetInput, {
    className: "mar-b-xl",
    flex: "1 1 80%",
    isMobile: true
  }), /*#__PURE__*/React.createElement(HouseInput, {
    className: "mar-b-xl",
    flex: "1 0 85px",
    isMobile: true
  }), /*#__PURE__*/React.createElement(FlatInput, {
    className: "mar-b-xl",
    flex: "1 0.6 142px"
  }), !isNullOrUndefined(isAddressHSConnected) ?
  /*#__PURE__*/
  // eslint-disable-next-line react/jsx-no-useless-fragment
  React.createElement(AvalibleWrapper, null, isAddressConnected ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ConnectButton, null), /*#__PURE__*/React.createElement(ConnectionStatus, {
    className: "mar-t-s"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ConnectionStatus, null), /*#__PURE__*/React.createElement(FallbackBannerHeading, {
    className: "mar-b-s mar-t-2xl",
    isMobile: true
  }), /*#__PURE__*/React.createElement(FallbackBanner, null))) : /*#__PURE__*/React.createElement(CheckButton, {
    align: "bottom",
    flex: "0 0 168px"
  }))
  // Tablet or Desktop
  : /*#__PURE__*/React.createElement(Flex, {
    className: className,
    gap: "m"
  }, /*#__PURE__*/React.createElement(CheckAddressWrapper, {
    flex: "1 0 68%",
    "data-t-id": "blocks-CheckAddressBlock"
  }, /*#__PURE__*/React.createElement(Anchor, {
    anchorId: FttbBlocks.CHECK_ADDRESS,
    "data-t-id": "blocks-CheckAddressBlock"
  }), /*#__PURE__*/React.createElement(MultiHeading, {
    className: "mar-b-m",
    phone: /*#__PURE__*/React.createElement(CallablePhone, null)
  }), /*#__PURE__*/React.createElement(WidgetContainer, null, /*#__PURE__*/React.createElement(AddressFinalForm, {
    className: "mar-b-m",
    "data-t-id": "blocks-CheckAddressBlock"
  }, /*#__PURE__*/React.createElement(Flex, {
    gap: "s",
    "data-t-id": "blocks-CheckAddressBlock"
  }, /*#__PURE__*/React.createElement(CityChangeButton, {
    width: "200px",
    "data-t-id": "blocks-CheckAddressBlock"
  }), /*#__PURE__*/React.createElement(StreetInput, {
    flex: "1 1 299px"
  }), /*#__PURE__*/React.createElement(HouseInput, {
    flex: "1 0 111px"
  }), /*#__PURE__*/React.createElement(FlatInput, {
    className: "mar-r-2xs",
    flex: "1 0.6 142px"
  }), /*#__PURE__*/React.createElement(CheckButton, {
    align: "bottom",
    flex: "1 0.6 142px"
  }))), /*#__PURE__*/React.createElement(AddressMap, null, /*#__PURE__*/React.createElement(AddressHousePoint, {
    "data-t-id": "blocks-CheckAddressBlock"
  }, renderTooltip && (isAddressHSConnected && /*#__PURE__*/React.createElement(AvailableHighSpeedMapTooltip, null) || isAddressConnected && /*#__PURE__*/React.createElement(AvailableMapTooltip, null) || /*#__PURE__*/React.createElement(NotAvailableMapTooltip, null)))))), isDesktop && /*#__PURE__*/React.createElement(Flex.Item, null, hasPopularTariff && isAddressConnected !== false ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PopularTariffHeading, {
    className: "mar-b-m mar-t-3xl"
  }), /*#__PURE__*/React.createElement(PopularTariff, null)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FallbackBannerHeading, {
    className: "mar-b-m mar-t-3xl"
  }), /*#__PURE__*/React.createElement(FallbackBanner, null))));
};
_CheckAddressBlock.propTypes = process.env.NODE_ENV !== "production" ? {
  isAddressConnected: PropTypes.bool,
  isAddressHSConnected: PropTypes.bool,
  hasPopularTariff: PropTypes.bool,
  className: PropTypes.string,
  renderTooltip: PropTypes.bool
} : {};
var _CheckAddressBlockHOC = withAnalyticsOnBlockView(_CheckAddressBlock);
export var CheckAddressBlock = compose(connect(function (state) {
  var isAddressConnected = getCheckAddressConnected(state);
  return {
    isAddressConnected: isAddressConnected,
    isAddressHSConnected: isAddressConnected && getCheckAddressHSConnected(state),
    hasPopularTariff: !!showPopularTariff(state) && !isEmpty(getTariffsList(state)),
    renderTooltip: getRenderTooltip(state),
    analyticBlockTitle: getCheckTitle(state),
    pageType: getAnalyticEventType(state),
    currentCity: getCurrentCity(state)
  };
}), defineBlock(FttbBlocks.CHECK_ADDRESS))(_CheckAddressBlockHOC);